import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberLossofhire = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M3 3.75a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v38a1 1 0 1 1-2 0v-37H5v37a1 1 0 1 1-2 0zM19 13.75a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v15a1 1 0 1 1-2 0v-14h-6v18.93a1 1 0 1 1-2 0zM35 23.75a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v9.93a1 1 0 1 1-2 0v-8.93h-6v4a1 1 0 1 1-2 0z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M51 33.75a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7h1a1 1 0 1 1 0 2H47.81a1 1 0 1 1 0-2H51zm2 7h6v-6h-6zm-52 1a1 1 0 0 1 1-1h14.19a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M32 29.25c-8.284 0-15 6.716-15 15s6.716 15 15 15 15-6.716 15-15-6.716-15-15-15m-17 15c0-9.389 7.611-17 17-17s17 7.611 17 17-7.611 17-17 17-17-7.611-17-17",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M32 35.25a1 1 0 0 1 1 1v13.586l4.293-4.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 1.414-1.414L31 49.836V36.25a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberLossofhire;
